import React from 'react'
import { Button, Checkbox, Select } from 'components/Form'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { Success } from 'utils/alerts'
import { convertString } from 'components/helper'
import { updateApiRecord } from 'services/RolesService'
import { getRolesData } from 'store/data/dataSlice'
import { moduleList } from 'utils/options'

const validationSchema = Yup.object().shape({
    group_id: Yup.string().required('Please select role'),
})

const Access = props => {
    const { initialData } = props
    const dispatch = useDispatch()
    const { rolesData, permissionList } = useSelector(state => state.listData)

    const handleSubmit = (value, { resetForm }) => {
        updateApiRecord(value.group_id, { permissions: value.permission_ids })
            .then(() => {
                dispatch(getRolesData())
                Success('Assign Permission Successfully!')
                resetForm()
            })
            .catch(error => console.log('Error: ', error))
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Access</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">Assign Permissions</h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik initialValues={initialData} validationSchema={validationSchema} onSubmit={handleSubmit}>
                            {({ values, touched, errors, resetForm }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                        <Field name="group_id">
                                            {({ field, form }) => (
                                                <Select
                                                    options={rolesData}
                                                    label="Role"
                                                    size="sm"
                                                    placeholder="Select"
                                                    className="md:col-span-2"
                                                    name="group_id"
                                                    error={errors.group_id && touched.group_id}
                                                    message={errors.group_id}
                                                    value={values?.group_id}
                                                    onChange={e => {
                                                        form.setFieldValue(field.name, e.target.value)
                                                        if (e.target.value) {
                                                            const role = rolesData.find(
                                                                ({ id }) => id?.toString() === e.target.value
                                                            )
                                                            form.setFieldValue(
                                                                'permission_ids',
                                                                role?.permissions?.map(item => item?.id) || []
                                                            )
                                                        } else {
                                                            form.setFieldValue('permission_ids', [])
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="grid grid-cols-2 mt-4 gap-x-4 gap-y-2 md:grid-cols-5">
                                        <label className={`col-span-5 block font-medium text-black dark:text-white`}>
                                            {'Permissions'}
                                        </label>
                                        {permissionList &&
                                            Object.keys(permissionList).map((key, index) => (
                                                <div key={index} className="mb-3">
                                                    <label
                                                        className={`block mb-3 text-sm font-medium text-black dark:text-white`}
                                                    >
                                                        {convertString(moduleList?.find(item => item.name === key)?.title) ??
                                                            convertString(key)}
                                                    </label>
                                                    {permissionList[key]?.map((value, Index) =>
                                                        ('all-products' === key ? Index > 2 : index >= 0) ? (
                                                            <Field name="permission_ids" key={value.id}>
                                                                {({ field, form }) => (
                                                                    <Checkbox
                                                                        className="mb-3"
                                                                        label={value.title}
                                                                        onChange={e => {
                                                                            let arr = [...values.permission_ids]

                                                                            if (arr.includes(value.id)) {
                                                                                arr = arr.filter(id => id !== value.id)
                                                                            } else {
                                                                                arr.push(value.id)
                                                                            }
                                                                            form.setFieldValue(field.name, arr)
                                                                        }}
                                                                        checked={
                                                                            values?.permission_ids
                                                                                ? values?.permission_ids.includes(value.id)
                                                                                : false
                                                                        }
                                                                    />
                                                                )}
                                                            </Field>
                                                        ) : null
                                                    )}
                                                </div>
                                            ))}
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            type="button"
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={resetForm}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

Access.defaultProps = {
    initialData: {
        group_id: '',
        permission_ids: [],
    },
}

export default Access
